import { Transform } from 'class-transformer';
import { temporalInstantTransformer } from 'src/lib/utilities/api/class-transformer-types';
import { WorkQueueTypes } from './work-queue.model';

export class WorkQueueEntityModel {
	queue_id: number;
	entity_type: string;
	entity_id: number;
	weight: number;
	@Transform(temporalInstantTransformer)
	completed: Temporal.Instant;
	@Transform(temporalInstantTransformer)
	created: Temporal.Instant;
	@Transform(temporalInstantTransformer)
	updated: Temporal.Instant;
	label: string;
	withdrawn: boolean;
	reassigned: boolean;
}

export interface WorkQueueEntityArgument {
	entity_type: string;
	entity_id: number;
	weight: number;
}

export class WorkQueueTrackerResponseModel {
	name: string;
	color: string;
	purpose: WorkQueueTypes;
	entity_id: number;
	queue_id: number;
	@Transform(temporalInstantTransformer)
	completed: Temporal.Instant;
}

export function WorkQueueTrackerResponseModel_ClassTransform_Type() {
	return WorkQueueTrackerResponseModel;
}
